module.exports = __webpack_public_path__ + "static/ivey-37802c405011389e29043ce651771cf6.svg";